import * as actionTypes from "./actionTypes";

const initialState = {
  data: null,
  payrollTypes: [],
  isLoading: false,
  templates: [],
  templateRequest: false,
  deleteTemplateRequest: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET:
      return { ...state, isLoading: true };
    case actionTypes.GET_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };
    case actionTypes.GET_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
